export default "__VITE_ASSET__utuFb2x4__"